import styles from './start.module.css';
import FullSize from '../../components/full-size';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/button';

function Start() {  

  const navigate = useNavigate();
  
  const start = () => {
    navigate("/first");
  }

  return (
    <FullSize bgColor='transparent'>
      <div className={styles.start_wrapper}>
        <div className={styles.text_container}>
          <h1 className={styles.title}>sQills Games 2026</h1>
          <p className={styles.intro}>Har ni vad som krävs för att få ert namn på pokalen?</p>
          <p className={styles.outro}>Otroligt tveksamt att Jonas klarar pressen.</p>
        <Button onClick={() => start()}>Let's go</Button>
        </div>
      </div>
    </FullSize>
  );
}

export default Start;
